import { Loader2 } from "lucide-react";

export function AuthLoadingSpinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-[#F97316]/80 to-[#D946EF]/80 dark:from-[#1e1b4b]/80 dark:to-[#4c1d95]/80">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-12 w-12 animate-spin text-white" />
        <p className="text-white text-sm">Checking authentication...</p>
      </div>
    </div>
  );
}
